import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {
  DevelopmentTool,
  NeuroMessage,
  useNeuroMessages,
} from '../../components';
import { useConversationTest } from '../state';

const CTPage = ({ className }) => {
  const conversationTestContext = useConversationTest();
  const {
    changeView,
    changeViewOptions,
    selectedView,
    views,
  } = conversationTestContext;
  const messageContext = useNeuroMessages();
  const [showDevMenu, setShowDevMenu] = useState(false);
  const componentClass = 'conversationTestPage';
  const classes = classnames(componentClass, className);
  const pageTitle =
    messageContext.getMessage('guide.name') || window.location.hostname;

  const viewChanger = (
    <fieldset className={`${componentClass}__viewChanger`}>
      <NeuroMessage id="convTest.viewOptions" tagName="legend" />
      <select
        value={selectedView.name}
        onChange={(e) => {
          changeView(views[e.target.value]);
        }}
        className={`${componentClass}__viewChanger`}
      >
        {Object.keys(views).map((viewKey) => {
          const view = views[viewKey];
          return (
            <option value={view.name} key={view.name}>
              {messageContext.formatIntlMessage({
                id: `convTest.viewOption.${view.name}`,
              })}
            </option>
          );
        })}
      </select>
    </fieldset>
  );

  const renderView = () => {
    const Component = selectedView.component;
    const props = selectedView?.props || {};
    const options = selectedView?.options || {};
    return <Component {...props} {...options} />;
  };

  const renderViewOptions = () => {
    const options = selectedView?.options || {};
    const viewOptions = Object.keys(options).map((optionKey) => {
      const optionIsActive = !!options[optionKey];
      const onToggleOption = () => {
        const updatedOptions = {
          ...options,
          [optionKey]: !optionIsActive,
        };
        changeViewOptions(updatedOptions);
      };
      return (
        <label
          className={optionIsActive ? 'checked' : ''}
          onClick={onToggleOption}
          key={optionKey}
        >
          <NeuroMessage id={`convTest.displayOption.${optionKey}`} tagName="span"/>
          <div className="checkmark" />
        </label>
      );
    });

    return (
      <fieldset>
        <NeuroMessage id="convTest.displayOptions" tagName="legend" />
        {viewOptions}
      </fieldset>
    );
  };

  return (
    <div className={classes}>
      <div className={`${componentClass}__menu`}>
        <NeuroMessage id="convTest.menu.title" tagName="h1" />
        {viewChanger}
        {renderViewOptions()}
      </div>
      <div className={`${componentClass}__content`}>
        <header className={`${componentClass}__header`}>
          <span className="guide-name">{pageTitle}</span>
          <section>
            <button
              className="btn btn-primary"
              onClick={() => setShowDevMenu(true)}
            >
              <NeuroMessage id="convTest.openDevTools" />
            </button>
          </section>
        </header>
        <div className="row modules">
          {selectedView?.component && renderView()}
        </div>
      </div>
      <DevelopmentTool
        enableForAnyEnvironment={true}
        enableMenu={showDevMenu}
        onMenuClose={() => setShowDevMenu(false)}
        isConversationTestPage={true}
      />
    </div>
  );
};

CTPage.propTypes = {
  className: PropTypes.string,
};

export default CTPage;
